import React from "react";


const Courses_detail = () => {
    return (
        <div>
            <div className="courses_area">
                <div className="inner_area">
                    <div className="box_area">
                        <div className="heading_area">
                            <h5>Courses</h5>
                        </div>
                        <div className="courses_info_area">
                            <div className="sub_heading_area">
                                <h6>Commerce</h6>
                            </div>
                            <div className="course_slide">
                                <div className="course_detail">
                                    <h4>MBA Business Analytics</h4>
                                    <p>Lorem ipsum dolor sit amet, con sectetur adip iscing elit. Maecenas con sectetur.</p>
                                    <div className="row">
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pe-0">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="fal fa-hourglass-start"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>2 years</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="far fa-book-open"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>Degree</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pe-0">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="fal fa-hourglass-start"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>Post graduation</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="far fa-clock"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>Full time</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="course_detail">
                                    <h4>MBA Business Analytics</h4>
                                    <p>Lorem ipsum dolor sit amet, con sectetur adip iscing elit. Maecenas con sectetur.</p>
                                    <div className="row">
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pe-0">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="fal fa-hourglass-start"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>2 years</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="far fa-book-open"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>Degree</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pe-0">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="fal fa-hourglass-start"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>Post graduation</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div className="inner_detail">
                                                <div className="icon_area">
                                                    <i class="far fa-clock"></i>
                                                </div>
                                                <div className="text_area">
                                                    <p>Full time</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="courses_info_area">
                            <div className="sub_heading_area">
                                <h6>Science</h6>
                            </div>
                            <div className="course_slide">
                                <div className="course_detail">
                                    <h4>Bachelor of Science [B.Sc]</h4>
                                    <p>Lorem ipsum dolor sit amet, con sectetur adip iscing elit. Maecenas con sectetur.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Courses_detail;


